import homepageHero from "../assets/images/homepagehero.png";
import aboutUsSection from "../assets/images/aboutussection.png";
import founderPortrait from "../assets/images/founderportrait.png";
import studentTestimonial1 from "../assets/images/studenttestimonial1.png";
import studentTestimonial2 from "../assets/images/studenttestimonial2.png";
import studentTestimonial3 from "../assets/images/studenttestimonial3.png";
import studentTestimonial4 from "../assets/images/studenttestimonial4.png";
import visaAssistance from "../assets/images/visaassistance.png";
import scholarship from "../assets/images/scholarship.png";
import resumeWriting from "../assets/images/resumewriting.png";
import studentAccommodation from "../assets/images/studentaccomodation.png";
import internationalSimCard from "../assets/images/internationalsimcard.png";
import airTickets from "../assets/images/airtickets.png";
import caseStudy from "../assets/images/casestudy.png";
import blogThumbnail from "../assets/images/blogthumbnail.png";
import logo from "../assets/images/logo.jpg";
import pricingBg from "../assets/images/pricepagebg.png";

export const IMAGES = {
  homepageHero,
  aboutUsSection,
  founderPortrait,
  testimonials: [
    studentTestimonial1,
    studentTestimonial2,
    studentTestimonial3,
    studentTestimonial4,
  ],
  visaAssistance,
  scholarship,
  resumeWriting,
  studentAccommodation,
  internationalSimCard,
  airTickets,
  caseStudy,
  blogThumbnail,
  logo,
  pricingBg,
};
